import { render, staticRenderFns } from "./Section5.vue?vue&type=template&id=ef2489ec&scoped=true&"
import script from "./Section5.vue?vue&type=script&lang=js&"
export * from "./Section5.vue?vue&type=script&lang=js&"
import style0 from "./Section5.vue?vue&type=style&index=0&id=ef2489ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2489ec",
  null
  
)

export default component.exports